import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { pinScrollTop } from "@/lib/pinScrollTop";

export function ScrollToTop() {
  const { pathname } = useLocation();

  // useLayoutEffect (non useEffect): il reset avviene PRIMA del paint. Con useEffect
  // la nuova pagina dipinge una volta allo scroll ereditato dalla pagina precedente
  // (spesso il fondo) e poi "scatta" in cima — visibile su iOS e Android/Despia.
  useLayoutEffect(() => {
    // Il browser non deve ripristinare da solo lo scroll al cambio route.
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";

    // Skip scroll to top for catalog sub-navigation (handled by Catalogo.tsx transition)
    // Se stiamo navigando dentro /catalogo/categoria/... non scrollare in alto subito
    if (pathname.includes("/catalogo/categoria/")) {
      // Lasciamo che sia Catalogo.tsx a gestire lo scroll reset dopo l'animazione
      return;
    }

    // La pagina offerta si scrolla da sola, in un contenitore suo: il documento lì è
    // alto quanto lo schermo e non scrolla. Resettare lo scroll del documento non le
    // serve — e fa danno: quando questo effetto parte la pagina PRECEDENTE è ancora
    // sullo schermo (misurato: al cambio rotta il documento è ancora alto quanto la
    // Home), quindi lo scrollTo la fa saltare in cima sotto gli occhi dell'utente.
    // Era quello lo "scatto" che si vedeva aprendo un'offerta.
    if (pathname.startsWith("/offerta/")) return;

    // Non basta un solo scrollTo: la WebView ri-applica il vecchio offset quando il
    // contenuto ricresce. Vedi src/lib/pinScrollTop.ts.
    pinScrollTop();
  }, [pathname]);

  return null;
}
